import { render, staticRenderFns } from "./CoursewareBlockComments.vue?vue&type=template&id=69d4c616&"
import script from "./CoursewareBlockComments.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports